import { LibraryBooks, Person } from '@mui/icons-material'
import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, Drawer, IconButton, List, ListItem, Menu, MenuItem, Paper, Toolbar } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import heroPic from '../../assets/brand-logo.svg'
import { useMobile } from '../../hooks/useMoblie'
import { useAuth } from '../../providers'
import { BOOKING_ROUTE } from '../../routes'
const drawerWidth = 250

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: `${theme.zIndex.drawer + 5} !important`,
        backgroundColor: '#ffff !important',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        border: 'none',
    },
    drawerPaper: {
        // backgroundColor: "#1769aa !important",
        width: drawerWidth,
        border: 'none',
    },
    drawerContainer: {
        overflow: 'auto',
        paddingTop: '90px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flexGrow: 1,
        paddingLeft: drawerWidth,
    },
}))

const DrawerList = [
    {
        label: 'Bookings',
        icon: <LibraryBooks />,
        link: BOOKING_ROUTE,
    },
]

const Dashboard = ({ showDashboard = true, children }) => {
    const classes = useStyles()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const redirectTo = useCallback(
        (url) => {
            navigate(url, {
                state: {
                    from: pathname,
                },
            })
        },
        [navigate, pathname]
    )
    const menuBtnRef = useRef()
    const [menuOpen, setMenuOpen] = useState(false)
    const handleClose = useCallback(() => {
        setMenuOpen(false)
    }, [])
    const handelOpen = useCallback(() => {
        setMenuOpen(true)
    }, [])
    const { user, logout, isUserLoggedIn } = useAuth()
    const handelLogout = useCallback(() => {
        if (isUserLoggedIn) {
            logout()
        }
        navigate('/login')
    }, [isUserLoggedIn, logout, navigate])
    const isMobile = useMobile()
    const [drawerOpen, setDrawerOpen] = useState(false)
    useEffect(() => {
        setDrawerOpen(!isMobile)
    }, [isMobile])

    return (
        <>
            <AppBar
                elevation={0}
                className={classes.appBar}
                position="fixed"
                sx={{
                    width: '100vw',
                    top: 0,
                    left: 0,
                    padding: '0 !important',
                }}
                variant="outlined"

                // className={classes.appBar}
            >
                <Toolbar
                    style={{
                        justifyContent: 'space-between',
                        p: 2,

                        backgroundColor: '#ffff !important',
                    }}
                >
                    {showDashboard && isMobile && (
                        <IconButton
                            onClick={() => {
                                setDrawerOpen(!drawerOpen)
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    <img
                        src={heroPic}
                        alt="project hero"
                        style={{
                            height: '40px',
                        }}
                    />
                    {showDashboard ? (
                        <>
                            <IconButton color="primary" ref={menuBtnRef} onClick={handelOpen}>
                                <Person />
                            </IconButton>
                            <Menu
                                anchorEl={menuBtnRef.current}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={menuOpen}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleClose}>{user.phoneNumber}</MenuItem>
                                <MenuItem onClick={handelLogout}>Logout</MenuItem>
                            </Menu>
                        </>
                    ) : (
                        ''
                    )}
                </Toolbar>
            </AppBar>
            <Drawer
                // className={classes.drawer}
                variant={isMobile ? 'persistent' : 'persistent'}
                open={drawerOpen}
                onClose={() => {
                    setDrawerOpen(false)
                }}
                sx={{
                    width: showDashboard ? drawerWidth : '0px',
                    flexShrink: 0,
                    border: 'none',
                }}
            >
                <Paper
                    // className={classes.drawerPaper}
                    elevation={0}
                    sx={{
                        width: showDashboard ? drawerWidth : '0px',
                        border: 'none',
                    }}
                >
                    <Box
                        // className={classes.drawerContainer}
                        sx={{
                            overflow: 'auto',
                            paddingTop: isMobile ? '56px' : '72px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <List>
                            {DrawerList.map((item, index) => (
                                <ListItem
                                    sx={(theme) => ({
                                        backgroundColor: pathname.includes(item.link)
                                            ? theme.palette.primary.main
                                            : null,
                                        color: pathname.includes(item.link)
                                            ? theme.palette.primary.contrastText
                                            : '#000',
                                        p: 2,
                                        '&:hover': {
                                            backgroundColor: pathname.includes(item.link)
                                                ? theme.palette.primary.light
                                                : null,
                                        },
                                    })}
                                    button
                                    key={index}
                                    onClick={() => {
                                        redirectTo(item.link)
                                    }}
                                >
                                    {/* <ListItemIcon>{item.icon}</ListItemIcon> */}
                                    {item.label}
                                </ListItem>
                            ))}
                        </List>
                        {/* logout button in drawer side bar */}
                        {/* <List style={{ margin: "auto 0 0" }}>
              <ListItem
                button
                sx={(theme) => ({
                  p: 2,
                })}
                onClick={() => {
                  if (isUserLoggedIn) {
                    return logout();
                  }
                  navigate("/login", {
                    state: {
                      from: pathname,
                    },
                  });
                }}
              >
                <ListItemIcon>
								<ExitToApp />
							</ListItemIcon>
              </ListItem>
            </List> */}
                        {/* <Tabs
						orientation="vertical"
						variant="scrollable"
						aria-label="Vertical tabs example"
						sx={{ borderRight: 1, borderColor: 'divider' }}>
						{DrawerList.map((item, index) => {
							return (
								<Tab
									label={item.label}
									onClick={() => {
										if (isUserLoggedIn) {
											return logout()
										}
										navigate('/login', {
											state: {
												from: pathname,
											},
										})
									}}
								/>
							)
						})}
					</Tabs> */}
                    </Box>
                </Paper>
            </Drawer>
            <main
                style={{
                    marginTop: '56px',
                    marginLeft: showDashboard ? (isMobile ? 0 : drawerWidth) : 0,
                    padding: isMobile ? '8px' : '24px',
                    // backgroundColor: showDashboard ? "" : "white"
                }}
            >
                <Box>{children}</Box>
            </main>
        </>
    )
}

export default Dashboard
